module.exports = __webpack_public_path__ + "static/media/bulb-on.7577ac2b.png";